import { districtListApi } from "../../api/district/districtListApi"
import { District } from "../../entities/district"

type PayloadShape = Parameters<typeof districtListApi>[0]

export async function districtListService(payload: PayloadShape, token?: null | string) {
	const district = await districtListApi(payload, token)
	return district as NonNullable<District[]>
}
